// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Member Edit Modal — scoped layout and “modern” field styles
 * (Classes like .modern-form-input are only used in this modal.)
 */

/* —— Modal shell —— */
.member-edit-modal.modal-container {
  max-width: min(880px, 100vw - 2rem);
  border: 1px solid var(--neutral-200);
  box-shadow:
    0 25px 50px -12px rgba(15, 23, 42, 0.15),
    0 0 0 1px rgba(15, 23, 42, 0.04);
}

.member-edit-modal .modal-header {
  background: linear-gradient(180deg, var(--neutral-50) 0%, white 100%);
  border-bottom: 1px solid var(--neutral-200);
}

.member-edit-modal .modal-header h2 {
  font-size: var(--text-xl);
  letter-spacing: -0.02em;
}

.member-edit-modal .modal-body {
  padding: var(--space-6) var(--space-6);
  scroll-padding-top: var(--space-4);
}

.member-edit-modal .modal-footer {
  gap: var(--space-3);
}

/* —— Sections —— */
.member-edit-modal .form-section {
  margin-bottom: var(--space-8);
  padding: var(--space-5);
  background: var(--neutral-50);
  border-radius: var(--radius-lg);
  border: 1px solid var(--neutral-200);
}

.member-edit-modal .form-section:last-of-type {
  margin-bottom: 0;
}

.member-edit-modal .form-section h3,
.member-edit-modal .form-section .section-title {
  margin: 0 0 var(--space-5) 0;
  font-size: var(--text-base);
  font-weight: var(--font-weight-semibold);
  color: var(--neutral-800);
  padding-bottom: var(--space-3);
  border-bottom: 1px solid var(--neutral-200);
  letter-spacing: -0.01em;
}

/* —— Grids —— */
.member-edit-modal .form-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-4);
}

@media (min-width: 640px) {
  .member-edit-modal .form-grid:not(.settings-permissions-grid) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  /* Full-width rows (e.g. long address) */
  .member-edit-modal .form-grid .modern-form-group--full {
    grid-column: 1 / -1;
  }
}

@media (min-width: 640px) {
  .member-edit-modal .form-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

/* Settings: responsive multi-column checkboxes */
.member-edit-modal .settings-permissions-grid {
  gap: var(--space-3);
}

@media (min-width: 520px) {
  .member-edit-modal .settings-permissions-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 900px) {
  .member-edit-modal .settings-permissions-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

/* —— Executive role cards —— */
.member-edit-modal .exec-roles-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-4);
}

@media (min-width: 900px) {
  .member-edit-modal .exec-roles-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    align-items: stretch;
  }
}

.member-edit-modal .exec-role-card,
.member-edit-modal .other-contact-card {
  margin: 0;
  padding: var(--space-4);
  background: white;
  border-radius: var(--radius-md);
  border: 1px solid var(--neutral-200);
  box-shadow: var(--shadow-sm);
}

.member-edit-modal .other-contact-card {
  margin-top: var(--space-4);
}

.member-edit-modal .exec-role-title,
.member-edit-modal .other-contact-title {
  margin: 0 0 var(--space-4) 0;
  font-size: var(--text-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--primary-800);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding-bottom: var(--space-2);
  border-bottom: 2px solid var(--primary-200);
}

.member-edit-modal .exec-role-fields {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

/* —— Modern field groups —— */
.member-edit-modal .modern-form-group {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 0;
}

.member-edit-modal .modern-form-label {
  display: block;
  margin: 0;
  cursor: pointer;
}

.member-edit-modal .modern-form-label .label-text {
  font-size: var(--text-sm);
  font-weight: var(--font-weight-medium);
  color: var(--neutral-700);
  line-height: 1.3;
}

.member-edit-modal .modern-form-input,
.member-edit-modal .modern-form-select {
  width: 100%;
  box-sizing: border-box;
  padding: var(--space-3) var(--space-4);
  border: 1px solid var(--neutral-300);
  border-radius: var(--radius-md);
  font-size: var(--text-base);
  font-family: inherit;
  line-height: 1.4;
  color: var(--neutral-900);
  background: white;
  transition:
    border-color var(--transition-base),
    box-shadow var(--transition-base);
}

.member-edit-modal .modern-form-input::placeholder {
  color: var(--neutral-400);
}

.member-edit-modal .modern-form-input:hover,
.member-edit-modal .modern-form-select:hover {
  border-color: var(--neutral-400);
}

.member-edit-modal .modern-form-input:focus,
.member-edit-modal .modern-form-select:focus {
  outline: none;
  border-color: var(--primary-600);
  box-shadow: 0 0 0 3px var(--primary-100);
}

.member-edit-modal .modern-form-input.error,
.member-edit-modal .modern-form-select.error {
  border-color: var(--error-500);
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.12);
}

.member-edit-modal .modern-error-text {
  display: block;
  font-size: var(--text-xs);
  color: var(--error-500);
  margin-top: 2px;
}

/* Native select: chevron */
.member-edit-modal .modern-form-select {
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right var(--space-3) center;
  background-repeat: no-repeat;
  background-size: 1.25em 1.25em;
  padding-right: var(--space-10);
}

/* —— Checkbox row (settings) —— */
.member-edit-modal .modern-form-group.checkbox-group {
  padding: var(--space-3) var(--space-4);
  margin: 0;
  background: white;
  border: 1px solid var(--neutral-200);
  border-radius: var(--radius-md);
  transition: border-color var(--transition-base), box-shadow var(--transition-base);
}

.member-edit-modal .modern-form-group.checkbox-group:hover {
  border-color: var(--neutral-300);
}

.member-edit-modal .modern-checkbox-label {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  cursor: pointer;
  margin: 0;
  font-size: var(--text-sm);
  color: var(--neutral-800);
  -webkit-user-select: none;
          user-select: none;
}

.member-edit-modal .modern-checkbox {
  width: 1.125rem;
  height: 1.125rem;
  margin: 0;
  flex-shrink: 0;
  accent-color: var(--primary-600);
  cursor: pointer;
}

.member-edit-modal .checkbox-text {
  line-height: 1.4;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.close-btn:hover:not(:disabled) {
  background: #e9ecef;
  color: #333;
}

.close-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.form-group input.error,
.form-group select.error,
.form-group textarea.error {
  border-color: #dc3545;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
}

.form-group input:disabled,
.form-group select:disabled,
.form-group textarea:disabled {
  background: #f8f9fa;
  color: #6c757d;
  cursor: not-allowed;
}

/* Checkbox Group (legacy) */
.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  font-size: 0.9rem;
  color: #333;
  -webkit-user-select: none;
          user-select: none;
}

.checkbox-label input[type="checkbox"] {
  display: none;
}

.checkmark {
  width: 20px;
  height: 20px;
  border: 2px solid #e9ecef;
  border-radius: 4px;
  background: white;
  position: relative;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.checkbox-label input[type="checkbox"]:checked+.checkmark {
  background: #0D3B66;
  border-color: #0D3B66;
}

.checkbox-label input[type="checkbox"]:checked+.checkmark::after {
  content: '✓';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 12px;
  font-weight: bold;
}

.checkbox-label input[type="checkbox"]:disabled+.checkmark {
  background: #f8f9fa;
  border-color: #dee2e6;
  cursor: not-allowed;
}

/* Error Messages */
.error-message {
  background: #f8d7da;
  color: #721c24;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  font-size: 0.9rem;
}

.field-error {
  color: #dc3545;
  font-size: 0.8rem;
  margin-top: 4px;
}

/* Responsive Design */
@media (min-width: 768px) {
  .form-row {
    grid-template-columns: 1fr 1fr;
  }

  .form-row:first-child {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 767px) {
  .modal-overlay {
    padding: 10px;
  }

  .modal-container {
    max-height: 95vh;
  }

  .modal-header {
    padding: 16px 20px;
  }

  .modal-header h2 {
    font-size: 1.3rem;
  }

  .modal-body {
    padding: 20px;
  }

  .modal-footer {
    padding: 16px 20px;
    flex-direction: column;
  }

  .btn {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .modal-header {
    padding: 12px 16px;
  }

  .modal-body {
    padding: 16px;
  }

  .modal-footer {
    padding: 12px 16px;
  }

  .form-section {
    margin-bottom: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/members/MemberEditModal.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,sBAAsB;AACtB;EACE,mCAAmC;EACnC,oCAAoC;EACpC;;oCAEkC;AACpC;;AAEA;EACE,qEAAqE;EACrE,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,4BAA4B;EAC5B,2BAA2B;EAC3B,wCAAwC;EACxC,yBAAyB;EACzB,8BAA8B;EAC9B,2CAA2C;EAC3C,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA,wCAAwC;EACxC;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA,iDAAiD;AACjD;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE;IACE,gDAAgD;IAChD,oBAAoB;EACtB;AACF;;AAEA;;EAEE,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,+BAA+B;EAC/B,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,4BAA4B;EAC5B,yBAAyB;EACzB,wCAAwC;EACxC,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,sCAAsC;EACtC,oCAAoC;EACpC,+BAA+B;EAC/B,2BAA2B;EAC3B,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB;;qCAEmC;AACrC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,aAAa;EACb,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;;EAEE,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,gBAAgB;EAChB,yDAAmP;EACnP,gDAAgD;EAChD,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA,kCAAkC;AAClC;EACE,sCAAsC;EACtC,SAAS;EACT,iBAAiB;EACjB,oCAAoC;EACpC,+BAA+B;EAC/B,kFAAkF;AACpF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,yBAAyB;EACzB,yBAAyB;EACzB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;EAGE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/**\n * Member Edit Modal — scoped layout and “modern” field styles\n * (Classes like .modern-form-input are only used in this modal.)\n */\n\n/* —— Modal shell —— */\n.member-edit-modal.modal-container {\n  max-width: min(880px, 100vw - 2rem);\n  border: 1px solid var(--neutral-200);\n  box-shadow:\n    0 25px 50px -12px rgba(15, 23, 42, 0.15),\n    0 0 0 1px rgba(15, 23, 42, 0.04);\n}\n\n.member-edit-modal .modal-header {\n  background: linear-gradient(180deg, var(--neutral-50) 0%, white 100%);\n  border-bottom: 1px solid var(--neutral-200);\n}\n\n.member-edit-modal .modal-header h2 {\n  font-size: var(--text-xl);\n  letter-spacing: -0.02em;\n}\n\n.member-edit-modal .modal-body {\n  padding: var(--space-6) var(--space-6);\n  scroll-padding-top: var(--space-4);\n}\n\n.member-edit-modal .modal-footer {\n  gap: var(--space-3);\n}\n\n/* —— Sections —— */\n.member-edit-modal .form-section {\n  margin-bottom: var(--space-8);\n  padding: var(--space-5);\n  background: var(--neutral-50);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--neutral-200);\n}\n\n.member-edit-modal .form-section:last-of-type {\n  margin-bottom: 0;\n}\n\n.member-edit-modal .form-section h3,\n.member-edit-modal .form-section .section-title {\n  margin: 0 0 var(--space-5) 0;\n  font-size: var(--text-base);\n  font-weight: var(--font-weight-semibold);\n  color: var(--neutral-800);\n  padding-bottom: var(--space-3);\n  border-bottom: 1px solid var(--neutral-200);\n  letter-spacing: -0.01em;\n}\n\n/* —— Grids —— */\n.member-edit-modal .form-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--space-4);\n}\n\n@media (min-width: 640px) {\n  .member-edit-modal .form-grid:not(.settings-permissions-grid) {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  /* Full-width rows (e.g. long address) */\n  .member-edit-modal .form-grid .modern-form-group--full {\n    grid-column: 1 / -1;\n  }\n}\n\n@media (min-width: 640px) {\n  .member-edit-modal .form-row {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n/* Settings: responsive multi-column checkboxes */\n.member-edit-modal .settings-permissions-grid {\n  gap: var(--space-3);\n}\n\n@media (min-width: 520px) {\n  .member-edit-modal .settings-permissions-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 900px) {\n  .member-edit-modal .settings-permissions-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n/* —— Executive role cards —— */\n.member-edit-modal .exec-roles-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--space-4);\n}\n\n@media (min-width: 900px) {\n  .member-edit-modal .exec-roles-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    align-items: stretch;\n  }\n}\n\n.member-edit-modal .exec-role-card,\n.member-edit-modal .other-contact-card {\n  margin: 0;\n  padding: var(--space-4);\n  background: white;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--neutral-200);\n  box-shadow: var(--shadow-sm);\n}\n\n.member-edit-modal .other-contact-card {\n  margin-top: var(--space-4);\n}\n\n.member-edit-modal .exec-role-title,\n.member-edit-modal .other-contact-title {\n  margin: 0 0 var(--space-4) 0;\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--primary-800);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  padding-bottom: var(--space-2);\n  border-bottom: 2px solid var(--primary-200);\n}\n\n.member-edit-modal .exec-role-fields {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n\n/* —— Modern field groups —— */\n.member-edit-modal .modern-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n  min-width: 0;\n}\n\n.member-edit-modal .modern-form-label {\n  display: block;\n  margin: 0;\n  cursor: pointer;\n}\n\n.member-edit-modal .modern-form-label .label-text {\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-medium);\n  color: var(--neutral-700);\n  line-height: 1.3;\n}\n\n.member-edit-modal .modern-form-input,\n.member-edit-modal .modern-form-select {\n  width: 100%;\n  box-sizing: border-box;\n  padding: var(--space-3) var(--space-4);\n  border: 1px solid var(--neutral-300);\n  border-radius: var(--radius-md);\n  font-size: var(--text-base);\n  font-family: inherit;\n  line-height: 1.4;\n  color: var(--neutral-900);\n  background: white;\n  transition:\n    border-color var(--transition-base),\n    box-shadow var(--transition-base);\n}\n\n.member-edit-modal .modern-form-input::placeholder {\n  color: var(--neutral-400);\n}\n\n.member-edit-modal .modern-form-input:hover,\n.member-edit-modal .modern-form-select:hover {\n  border-color: var(--neutral-400);\n}\n\n.member-edit-modal .modern-form-input:focus,\n.member-edit-modal .modern-form-select:focus {\n  outline: none;\n  border-color: var(--primary-600);\n  box-shadow: 0 0 0 3px var(--primary-100);\n}\n\n.member-edit-modal .modern-form-input.error,\n.member-edit-modal .modern-form-select.error {\n  border-color: var(--error-500);\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.12);\n}\n\n.member-edit-modal .modern-error-text {\n  display: block;\n  font-size: var(--text-xs);\n  color: var(--error-500);\n  margin-top: 2px;\n}\n\n/* Native select: chevron */\n.member-edit-modal .modern-form-select {\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n  background-position: right var(--space-3) center;\n  background-repeat: no-repeat;\n  background-size: 1.25em 1.25em;\n  padding-right: var(--space-10);\n}\n\n/* —— Checkbox row (settings) —— */\n.member-edit-modal .modern-form-group.checkbox-group {\n  padding: var(--space-3) var(--space-4);\n  margin: 0;\n  background: white;\n  border: 1px solid var(--neutral-200);\n  border-radius: var(--radius-md);\n  transition: border-color var(--transition-base), box-shadow var(--transition-base);\n}\n\n.member-edit-modal .modern-form-group.checkbox-group:hover {\n  border-color: var(--neutral-300);\n}\n\n.member-edit-modal .modern-checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  cursor: pointer;\n  margin: 0;\n  font-size: var(--text-sm);\n  color: var(--neutral-800);\n  user-select: none;\n}\n\n.member-edit-modal .modern-checkbox {\n  width: 1.125rem;\n  height: 1.125rem;\n  margin: 0;\n  flex-shrink: 0;\n  accent-color: var(--primary-600);\n  cursor: pointer;\n}\n\n.member-edit-modal .checkbox-text {\n  line-height: 1.4;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  padding: 4px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.close-btn:hover:not(:disabled) {\n  background: #e9ecef;\n  color: #333;\n}\n\n.close-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.form-group input.error,\n.form-group select.error,\n.form-group textarea.error {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);\n}\n\n.form-group input:disabled,\n.form-group select:disabled,\n.form-group textarea:disabled {\n  background: #f8f9fa;\n  color: #6c757d;\n  cursor: not-allowed;\n}\n\n/* Checkbox Group (legacy) */\n.checkbox-group {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  color: #333;\n  user-select: none;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  display: none;\n}\n\n.checkmark {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #e9ecef;\n  border-radius: 4px;\n  background: white;\n  position: relative;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.checkbox-label input[type=\"checkbox\"]:checked+.checkmark {\n  background: #0D3B66;\n  border-color: #0D3B66;\n}\n\n.checkbox-label input[type=\"checkbox\"]:checked+.checkmark::after {\n  content: '✓';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: white;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.checkbox-label input[type=\"checkbox\"]:disabled+.checkmark {\n  background: #f8f9fa;\n  border-color: #dee2e6;\n  cursor: not-allowed;\n}\n\n/* Error Messages */\n.error-message {\n  background: #f8d7da;\n  color: #721c24;\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 16px;\n  font-size: 0.9rem;\n}\n\n.field-error {\n  color: #dc3545;\n  font-size: 0.8rem;\n  margin-top: 4px;\n}\n\n/* Responsive Design */\n@media (min-width: 768px) {\n  .form-row {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .form-row:first-child {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 767px) {\n  .modal-overlay {\n    padding: 10px;\n  }\n\n  .modal-container {\n    max-height: 95vh;\n  }\n\n  .modal-header {\n    padding: 16px 20px;\n  }\n\n  .modal-header h2 {\n    font-size: 1.3rem;\n  }\n\n  .modal-body {\n    padding: 20px;\n  }\n\n  .modal-footer {\n    padding: 16px 20px;\n    flex-direction: column;\n  }\n\n  .btn {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .modal-header {\n    padding: 12px 16px;\n  }\n\n  .modal-body {\n    padding: 16px;\n  }\n\n  .modal-footer {\n    padding: 12px 16px;\n  }\n\n  .form-section {\n    margin-bottom: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
